__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@bonusly/monarch";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@bonusly/application", "1.1.0", () => (Promise.all([__webpack_require__.e(312), __webpack_require__.e(389)]).then(() => (() => (__webpack_require__(6389))))));
			register("@bonusly/http-client", "1.0.1", () => (Promise.all([__webpack_require__.e(103), __webpack_require__.e(181), __webpack_require__.e(312), __webpack_require__.e(382), __webpack_require__.e(504), __webpack_require__.e(279)]).then(() => (() => (__webpack_require__(6043))))));
			register("@bonusly/telemetry", "1.0.0", () => (Promise.all([__webpack_require__.e(698), __webpack_require__.e(312), __webpack_require__.e(382), __webpack_require__.e(598)]).then(() => (() => (__webpack_require__(4598))))));
			register("@bonusly/who-am-i", "2.3.4", () => (Promise.all([__webpack_require__.e(103), __webpack_require__.e(655), __webpack_require__.e(181), __webpack_require__.e(109), __webpack_require__.e(312), __webpack_require__.e(382), __webpack_require__.e(710)]).then(() => (() => (__webpack_require__(8338))))));
			register("@chakra-ui/react", "2.8.2", () => (Promise.all([__webpack_require__.e(378), __webpack_require__.e(1), __webpack_require__.e(312), __webpack_require__.e(163), __webpack_require__.e(334)]).then(() => (() => (__webpack_require__(7378))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(551), __webpack_require__.e(312)]).then(() => (() => (__webpack_require__(2551))))));
			register("react-i18next", "14.1.1", () => (Promise.all([__webpack_require__.e(562), __webpack_require__.e(312)]).then(() => (() => (__webpack_require__(3181))))));
			register("react-router-dom", "6.22.3", () => (Promise.all([__webpack_require__.e(15), __webpack_require__.e(312), __webpack_require__.e(163)]).then(() => (() => (__webpack_require__(5015))))));
			register("react", "18.2.0", () => (__webpack_require__.e(462).then(() => (() => (__webpack_require__(1462))))));
			initExternal(9490);
			initExternal(2963);
			initExternal(9807);
			initExternal(6811);
			initExternal(2040);
			initExternal(7670);
			initExternal(791);
			initExternal(5023);
			initExternal(4503);
			initExternal(3251);
			initExternal(5676);
			initExternal(3381);
			initExternal(7690);
			initExternal(2810);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};